import ListGroup from 'react-bootstrap/ListGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';

const exp = [
  {
    date: 'August 2022 - September 2022',
    title: 'Budtender',
    subtitle: 'GreenDragon',
    desc: `Interact with customers of all backgrounds in order to recommend and sell them the best marijuana products that may help with their pain or any other issues they come to the shop for. Clean, maintain, and organize the store in order to provide a healthy work environment. Effectively communicate with shift leads and other budtenders during shifts to keep the store running smoothly.`,
    id: 1
  },
  {
    date: 'August 2021 - May 2022',
    title: 'Budtender',
    subtitle: 'Kind Care of Colorado',
    desc: `Interact with customers of all backgrounds in order to recommend and sell them the best marijuana products that may help with their pain or any other issues they come to the shop for. Clean, maintain, and organize the station assigned upon shift start and the store in order to provide the best experience for customers. Effectively communicate with shift leads and other budtenders during shifts to keep the store running smoothly. Keep healthy and professional relationships with customers in order to keep them coming back to the store.`,
    id: 2
  },
  {
    date: 'November 2018 - January 2020',
    title: 'Line Cook',
    subtitle: 'Rare Italian',
    desc: `Prepare and clean the station(s) assigned to me before the start of the shift to maintain a healthy eating environment for customers. Communicate with Chef, Sous Chef, and other line cooks within a fast paced environment to get the food out to the customers in the order that is required by the restaurant. Clean the kitchen after shift and help out the dishwasher if he/she is behind so that the back- of-house is able to maintain a healthy relationship.`,
    id: 3
  },
  {
    date: 'December 2017 - August 2020',
    title: 'Full Stack Web Developer',
    subtitle: 'Freelance',
    desc: `Planned and engineered RESTful and SQL web services to manipulate dynamic datasets. Developed landing pages, dashboards and online applications using JavaScript, Vue.js/React.js, and Node.js. Worked with Graphic Designers to synchronize web presence with brand identity and logo.`,
    id: 4
  },
  {
    date: 'January 2018 - August 2020',
    title: 'Data Analyst',
    subtitle: 'Dilovi',
    desc: `Reach out to potential partners and clients in order to establish a data relationship with them. Utilize Excel and the VBA language to write scripts that will automate data entry. Develop web applications that interact with the data to speed up the process of data entry.`,
    id: 5
  },
  {
    date: 'July 2018 - August 2018',
    title: 'Seasonal Bartender',
    subtitle: 'Ravinia Music Festival',
    desc: `Serve alcoholic and non-alcoholic beverages to customers while interacting with them. Communicate with the runners in order to make sure inventory is fully stocked. Keep track of customer orders while calculating the total of their beverages.`,
    id: 6
  },
  {
    date: 'September 2016 - May 2018',
    title: 'Student Worker',
    subtitle: 'Elmhurst University Student Activities Center',
    desc: `Provide students and campus organizations with supplies and gaming equipment. Inform students and alumni about campus events and activities. Organize and decorate the center in order to provide a comfortable environment.`,
    id: 7
  },
  {
    date: 'May 2017 - August 2017',
    title: 'Seasonal Warehouse Associate',
    subtitle: 'Gold Medal Chicago',
    desc: `Efficiently complete customer orders. Help drivers with their daily deliveries. Clean and maintain the warehouse.`,
    id: 8
  },
  {
    date: 'January 2016 - August 2016',
    title: 'Data Analyst Intern',
    subtitle: 'rVue',
    desc: `Reach out and create relationships with companies. Gather DOOH data from companies to put into rVue platform by using Excel. Create new ways to receive and sort data in order to speed up the process.`,
    id: 9
  },
  {
    date: 'September 2015 - January 2016',
    title: 'Student Caller',
    subtitle: 'Elmhurst University Phonathon',
    desc: `Build relationships with alumni and in the process raising money for the college which goes to scholarships, updated technology for the classrooms, and a variety of other well needed funding. Update alumni contact information and informing them about campus events and the college news.`,
    id: 10
  },
  {
    date: 'October 2014 - December 2014',
    title: 'Porter',
    subtitle: 'Glendale Nissan',
    desc: `Created system of manually washing and drying two cars at a time which cut the waiting time of the customers and in return improved company's overall customer happiness. Handled newly purchased customer vehicles by thoroughly cleaning every detail of the car. Drove company car to perform car/part trades at another Nissan location.`,
    id: 11
  },
  {
    date: 'November 2013 - January 2014',
    title: 'Seasonal Sales Associate',
    subtitle: 'JCPenney',
    desc: `Advertised store credit card to customers. Worked within a team to ensure customer satisfaction. Located any item the customer wanted that was in the store. Handled cash register money and made sure that the store was in perfect condition during closing hours.`,
    id: 12
  }
]

const items = exp.map(exp =>
  <ListGroup.Item key={exp.id}>
    {exp.date}
    <ul />
    <p>{exp.title}, <small>{exp.subtitle}</small></p>
    <ul />
    <DropdownButton title='Description' variant='secondary'>
      <Dropdown.ItemText>{exp.desc}</Dropdown.ItemText>
    </DropdownButton>
  </ListGroup.Item>
);

function Experience() {
  return (
    <div>
      <h2>Experience</h2>
      <ListGroup variant='flush'>
        {items}
      </ListGroup>
    </div>
  );
}

export default Experience;
